var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChatSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.6345 24.4752L19.2765 19.1122L24.6345 24.4752ZM22.2458 11.9448C22.2458 14.6351 21.1762 17.2152 19.2723 19.1174C17.3683 21.0197 14.7861 22.0884 12.0936 22.0884C9.40106 22.0884 6.81881 21.0197 4.91491 19.1174C3.01101 17.2152 1.94141 14.6351 1.94141 11.9448C1.94141 9.2546 3.01101 6.67455 4.91491 4.77226C6.81881 2.86997 9.40106 1.80127 12.0936 1.80127C14.7861 1.80127 17.3683 2.86997 19.2723 4.77226C21.1762 6.67455 22.2458 9.2546 22.2458 11.9448V11.9448Z",
    stroke: "#A7A7A7",
    strokeWidth: 2.3871,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatSearch);
export default __webpack_public_path__ + "static/media/chat-search.e2896ab84f8e35e76d1016bc79185473.svg";
export { ForwardRef as ReactComponent };